import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row, Alert, Image, Stack } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbDivider, BreadcrumbSection, Button, Dimmer, Icon, Label, Loader } from "semantic-ui-react";
import ProductCard from "../../component/ProductCard";
import ProductFilter from "../../component/ProductFilter";
import nodata from "../../assets/no_data.png"
import { useMyGlobal } from "../../component/GlobalData";
import { sha256 } from "../../component/utility";

const ProductList = () => {
    const category = useLocation().state
    const path = useLocation().pathname
    const param = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const keyWords = queryParams.get('search')
    const idCustomer = (localStorage.getItem('loginData') !== null) ? JSON.parse(localStorage.getItem('loginData')).id : null
    const [products, setProducts] = useState([])
    const [colorList, setColorList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [sizeList, setSizeList] = useState([])
    const { token } = useMyGlobal()
    const [load, setLoad] = useState(true)
    const [hideImageEmpty, setHideImageEmpty] = useState(true)
    const { wishData, isPortrait, windowWidth, categoryAll } = useMyGlobal()
    const [directLinkCat, setDirectLinkCat] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)
    const pagePerLoad = 12
    const [jmlProd, setJmlProd] = useState(pagePerLoad)
    const [loaderProduct, setLoaderProduct] = useState(false)
    const [disableLoad, setDisableLoad] = useState(false)
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);

    const pathSegments = path
        .split('/')
        .filter(segment => segment && isNaN(Number(segment)))
        .map(segment => decodeURIComponent(segment.replace(/-/g, ' ')))

    const EmptyCategory = () => {
        return (
            <Alert variant="secondary" className="text-start mt-5">
                <Alert.Heading>This category does not contain any products!</Alert.Heading>
                <div>
                    This category does not contain items, maybe no items have been added to this category,
                    please click <Link to="/">Back to home</Link> to return to the category menu
                </div>
            </Alert>
        )
    }



    // const getFlashsale = (idFs) => {
    //     const param = {
    //         id_fs : idFs
    //     }

    //     axios({
    //         method: "POST",
    //         url: "http://localhost/api_hoops/controler/event.php/?index=3",
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded',
    //         },
    //         data: param
    //     })
    //     .then(res => {
    //         console.log(res.data)
    //     })
    // }

    // useEffect(() => {
    //     const observer = new IntersectionObserver((entries) => {
    //         if (entries[0].isIntersecting) {
    //             console.log(`test: ${loaderProduct}`)
    //             handleClickLoadMore()
    //         }
    //     });

    //     if (observerRef.current) observer.observe(observerRef.current);
    //     return () => observer.disconnect();
    // }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50 && !loaderProduct && hasMore
            ) {
                handleClickLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loaderProduct, hasMore]);

    const getProductList = async (id_category, id_customer, option, pages, jumlahData) => {
        setLoaderProduct(true)

        const param = new URLSearchParams()
        if (id_customer === null) { id_customer = false }

        param.append('id_category', id_category)
        param.append('id_customer', id_customer)
        param.append('option', option)
        param.append('page', pages)
        param.append('limit', jumlahData)
        // param.append('tkn', sha)
        // console.log(keyWords !== '' && keyWords !== '')
        // console.log(keyWords)
        // console.log(path)
        if (category?.hasOwnProperty('search_value')) {
            param.append('param', category.search_value)
        }

        // if (keyWords !== null && keyWords !== '') {
        //     param.append('param', keyWords)
        // }

        setLoad(true)
        await axios({
            method: "POST",
            url: `${global.ERP}api_web/controler/product.php?index=270`,
            // url: "https://hoopsindonesia.co.id/api_hoops/controler/product.php?index=1",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                let data = []
                let colors = []
                let brand = []
                let size = []

                if (response.data.state == 200) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data
                        data.map((i, d) => i.color.map((x) => colors.push(x)))
                        data.map((i, d) => i.size.map((x) => size.push(x)))
                        if (category?.from !== 'parent') {
                            data.map((i, d) => i.category_parent.map((x) => brand.push(x)))
                            setBrandList(Object.values(brand.reduce((acc, item) => {
                                if (!acc[item.id_category] && item.on_page === '1') {
                                    acc[item.id_category] = {
                                        id_category: item.id_category,
                                        category_name: item.category_name,
                                        on_page: item.on_page,
                                    };
                                }
                                return acc
                            }, {})).sort((a, b) => a.category_name.localeCompare(b.category_name)))
                        } else {
                            if (category.hasOwnProperty('child')) {
                                category.child.map((i, d) => brand.push(i))
                            }
                            setBrandList(Object.values(brand.reduce((acc, item) => {
                                if (!acc[item.id_category_child]) {
                                    acc[item.id_category_child] = {
                                        id_category: item.id_category_child,
                                        category_name: item.category_name,
                                        on_page: '0',
                                    };
                                }
                                return acc
                            }, {})).sort((a, b) => a.category_name.localeCompare(b.category_name)))
                        }

                        if (response.data.data.length > 0) {
                            setLoad(false)
                            setHideImageEmpty(true)
                        } else {
                            setLoad(false)
                            setHideImageEmpty(false)
                        }
                        // SET DATA PRODUK
                        setProducts(prevNew => {
                            // Filter data baru yang belum ada di dalam newProduct
                            const filteredData = data.filter(item =>
                                !prevNew.some(prevItem => prevItem.id_product === item.id_product)
                            );
                            // Gabungkan data lama dengan data baru yang sudah difilter
                            return [...prevNew, ...filteredData];
                        });
                        setHasMore(true)
                    } else {
                        setDisableLoad(true)
                        setHasMore(false)
                    }
                    // GROUPING ARRAY SUPAYA GA DUPLICAT
                    setColorList(Object.values(colors.reduce((acc, item) => {
                        if (!acc[item.id_color]) acc[item.id_color] = {
                            id_color: item.id_color,
                            color_main: item.color_main,
                            color_secondary: item.color_secondary,
                            color_accent: item.color_accent
                        }

                        return acc
                    }, {})))

                    const sizeGroup = [...new Set(size)].map(String)

                    const convertedSizeGroup = sizeGroup.map((value) => {
                        // Jika nilai adalah pecahan seperti '1½'
                        const fractionMatch = value.match(/(\d+)½/);
                        if (fractionMatch) {
                            const wholeNumber = fractionMatch[1] || '0';
                            return `${wholeNumber}.5`;
                        }

                        // Jika nilai bukan pecahan, kembalikan nilai asli
                        return value;
                    });

                    const convertedNumericGroup = sizeGroup.map((value) => {
                        // Jika nilai adalah angka atau pecahan seperti '1½'
                        const numericValue = !isNaN(parseFloat(value)) ? parseFloat(value) : value;

                        return numericValue;
                    });
                    // Membuat dua array: satu berisi nilai numerik, satu berisi nilai yang tidak bisa diurutkan
                    const sortableValues = convertedNumericGroup.filter(value => typeof value === 'number');
                    const nonSortableValues = convertedNumericGroup.filter(value => typeof value !== 'number');

                    // Mengurutkan nilai numerik
                    const sortedNumericValues = sortableValues.sort((a, b) => a - b);

                    // Menggabungkan kembali nilai yang telah diurutkan dengan nilai yang tidak bisa diurutkan
                    const finalResult = [...sortedNumericValues, ...nonSortableValues];
                    setSizeList(finalResult);
                }
            }).finally(() => {
                setLoaderProduct(false)
                setLoad(false)
            })

    }

    const handleClickLoadMore = () => {
        const page = currentPage + pagePerLoad
        setCurrentPage(page)
        getProductList(param.categoryId, idCustomer, category?.from, page, jmlProd)
    }

    useEffect(() => {

        if (category !== null) {
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])
            getProductList(param.categoryId, idCustomer, category?.from, 0, jmlProd)
            document.title = category.hasOwnProperty('child') && category?.selected_child > 0 ? category.child.find(i => i.id_category_child == category.selected_child)?.category_name : category?.category_name
            window.scrollTo(0, 0)
        }
    }, [category, param])

    useEffect(() => {
        if (category === null) {
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])
            // let part = path.split('/').filter(Boolean)
            // let idCategoryChild = part[part.length - 2]
            // console.log('cat child',idCategoryChild)
            // console.log('param',param)
            getProductList(param.categoryId, null, 'child', 0, jmlProd)

            setDirectLinkCat(categoryAll.find(category =>
                category.child.some(child => child.id_category_child == param.categoryId)
            ))
        }
    }, [path, categoryAll, category])

    return (
        <section style={{ height: '100%', minHeight: '100vh' }}>
            <Row className="justify-content-center" style={{ marginTop: '6vh' }}>
                <Col xs={12} md={12} xl={12} className="">
                    <img
                        className="img-fluid"
                        src={category ? category.header_image : directLinkCat ? directLinkCat.header_image : ''}
                        width={'100%'}
                    />
                </Col>
            </Row>

            <Container>
                <Row className="mt-3 mb-3">
                    <Col xl={6} lg={12} md={12} sm={12} className="text-start">
                        <Breadcrumb size="tiny">
                            <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                            <BreadcrumbDivider />
                            <BreadcrumbSection active className="text-uppercase">{pathSegments[1]}</BreadcrumbSection>
                        </Breadcrumb>
                    </Col>
                </Row>
                <Row className="mt-3 mb-3">
                    <Col xl={12} lg={12} md={12} className="text-start">
                        {category?.category_name == 'HOME' ? <h1>PRODUCT SEARCH</h1> :
                            <h1>{category ? category.hasOwnProperty('child') && category?.selected_child > 0 ? category.child.find(i => i.id_category_child == category.selected_child)?.category_name : category?.category_name : directLinkCat?.child.find(c => c.id_category_child == param.categoryId)?.category_name}</h1>
                        }
                        <h3 className="fs-5 fw-light">
                            {
                                category ?
                                    category?.hasOwnProperty('search_value') ? `Search result for "${category.search_value}"`
                                        : category?.hasOwnProperty('child') && category?.selected_child > 0 ? category.child.find(i => i.id_category_child == category.selected_child)?.description : category?.description
                                    : directLinkCat?.child.find(c => c.id_category_child == param.categoryId)?.description
                            }
                        </h3>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xxl={12} xl={12} className="text-start">
                        {
                            (category?.isDefault == 0) ?
                                <ProductFilter
                                    setProducts={(category?.hasOwnProperty('search_value')) ? null : setProducts}
                                    categoryId={param.categoryId}
                                    categoryFrom={category?.from}
                                    colorList={colorList}
                                    brandList={brandList}
                                    sizeList={sizeList}
                                    doGetProduct={false}
                                /> : <></>
                        }
                    </Col>
                </Row>
                <Row className="mt-2" >
                    <Dimmer active={load} inverted>
                        <Loader active={load}>Loading..</Loader>
                    </Dimmer>
                    {
                        (products) && (
                            (products.length > 0) && (
                                products.map((item, i) => {
                                    const isWish = wishData.some(wishItem => wishItem.id_product === item.id_product);
                                    return (
                                        <ProductCard
                                            data={item} key={i} isWish={isWish}
                                        />
                                    )
                                })
                            )
                        )
                    }
                </Row>
                <Row className="mt-2">
                    {products.length > 0 ?
                        <Col className="text-center">
                            {/* <Button
                                fluid={windowWidth <= 600 ? true : false}
                                content={!disableLoad ? 'Load More' : "All Product Loaded"}
                                onClick={() => handleClickLoadMore()}
                                loading={loaderProduct}
                                disabled={disableLoad}
                                basic
                                color="orange"
                                icon={!disableLoad ? 'redo' : 'ban'}
                            /> */}
                            {
                                hasMore ?
                                    <div className="pb-2" style={{ height: "20px", textAlign: "center" }}>
                                        {
                                            loaderProduct ?
                                                <Loader active inline size="small" />
                                                :
                                                <Icon name="angle double down" size="big" className="bounce" />
                                        }
                                    </div>
                                    :
                                    <div style={{ height: "20px", textAlign: "center" }}>
                                        <p>All product has been loaded</p>
                                    </div>
                            }
                        </Col>
                        :
                        <Col>
                            <Image src={nodata} width="200" fluid />
                        </Col>
                    }
                </Row>
            </Container>
        </section>
    )
}

export default ProductList;